import styled from 'styled-components';
const VisualTag = styled.span `
  display: inline-flex;
  flex-direction: row;
  padding: 4px 6px;
  border-radius: 12px;
  background: ${({ theme, blue }) => blue ? theme.colors.supportInfo02 : theme.colors.supportSuccess01};
  font-size: 10px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  line-height: 8px;
  color: ${({ theme, blue }) => (blue ? theme.colors.supportInfo01 : theme.colors.text04)};
  ${({ customCss }) => customCss || ''}
`;
export default VisualTag;
//# sourceMappingURL=VisualTag.js.map